import { render, staticRenderFns } from "./PatientCharges.vue?vue&type=template&id=2023dc48&"
import script from "./PatientCharges.vue?vue&type=script&lang=js&"
export * from "./PatientCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports